import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { FiltersMenuActionsType } from 'routes/Filters/Filters.types';
import ModalDialog from 'shared/modal/dialog';
import { Filters } from 'data/filters/filters.types';
import './filters-list-menu.scss';

type Props = {
  selectedFilters?: Filters;
  hasPrivilegeToCreateNew: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const FiltersListMenu: FunctionComponent<Props> = ({
  selectedFilters,
  hasPrivilegeToCreateNew,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedFilters == null) {
    return null;
  }

  return (
    <div data-testid="FiltersListMenu" className="filters-list-menu">
      {/* {hasPrivilegeToCreateNew && (
        <Button
          className="filters-list-menu-button"
          data-testid={`${FiltersMenuActionsType.Edit}-button`}
          text={t('collectionFunction.grid.edit')}
          onClick={onEdit}
        />
      )} */}
      {hasPrivilegeToDelete && (
        <Button
          className="filters-list-menu-button"
          data-testid={`${FiltersMenuActionsType.Delete}-button`}
          text={t('filter.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('filter.deletePopup.title')}
        displayMessage={t('filter.deletePopup.message', { name: selectedFilters.fId })}
        actionText={t('filter.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default FiltersListMenu;
